import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { UtilsService } from 'src/app/services/utils.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { MANAGE_LINE_CONST } from 'src/app/common/core/common.constants';
import { CommonConfirmationModalComponent } from '../common-confirmation-modal/common-confirmation-modal.component';
import { isNullOrUndefined } from 'src/app/services/utils';

@Component({
  selector: 'app-sim-protection-ban-level',
  templateUrl: './sim-protection-ban-level.component.html',
  styleUrls: ['./sim-protection-ban-level.component.scss']
})
export class SimProtectionBanLevel implements OnInit {

  authoringContentData: any;
  header: any;
  footer:any;
  ctaSubmit: any;
  ctaCancel: any;
  actionOn: any;
  actionOff: any;
  ngbModalOptions: NgbModalOptions;
  requestPayLoad: any ={};
  authInfo: any;
  isActionOn: boolean = null;
  @Output() isYesButtonClicked = new EventEmitter<boolean>();
  isSubmitEnabled: boolean = false;

  constructor(private _cacheSvc: HttpCacheService, private _utilSvc: UtilsService, public manageLineService: ManageLineService,  public utilsSvc: UtilsService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.authoringContentData = this._utilSvc.getContentDataFromSession();
    this.isSubmitDisabled();
  }

  onClickSubmit(){
    this.ngbModalOptions = {
      backdrop: "static",
      keyboard: false,
      centered: false,
      container: "#am-container-custom",
    };

    this.manageLineService.manageBlockStatus(this.requestPayLoad).subscribe({
      next: (response) =>  {
        if (!isNullOrUndefined(response) && !isNullOrUndefined(response.status)
          && response.status === 'Success') {
          this.manageLineService.close();
          const simProtectionSuccessModalRef = this.modalService.open(CommonConfirmationModalComponent,this.ngbModalOptions);
             
          simProtectionSuccessModalRef.componentInstance.message = this.isActionOn ? this.authoringContentData.manageLine.simProtection.simProtectionOn.completedMessage?.replace('{{transactionId}}', response.accountTransactionRefNum) : this.authoringContentData.manageLine.simProtection.simProtectionOff.completedMessage?.replace('{{transactionId}}', response.accountTransactionRefNum);
          simProtectionSuccessModalRef.componentInstance.ctaAllow = this.authoringContentData.manageLine.closeCTA;
          simProtectionSuccessModalRef.componentInstance.action = true;
          simProtectionSuccessModalRef.componentInstance.header = this.isActionOn ? this.authoringContentData.manageLine.simProtection.simProtectionOn.completedHeader : this.authoringContentData.manageLine.simProtection.simProtectionOff.completedHeader;
             
          simProtectionSuccessModalRef.componentInstance.isYesButtonClicked.subscribe((closeButtonClicked)=>{
          if(closeButtonClicked){
            this.modalService.dismissAll();
            this.isYesButtonClicked.emit(true);
          }});
        } else {
          this.utilsSvc.errorHandling(undefined);
        }
      },
      error: (err) => {
        this.manageLineService.close();
        this.utilsSvc.errorHandling(err);
      }
    });
  }

  onClickCancel() {
    this.manageLineService.close();
  }

  onClickAction(isOn){
    this.isActionOn = isOn;
    let ban = this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN);
    this.requestPayLoad = {
        "ban": ban,
        "transType": "Sim-Swap",
        "action": (this.isActionOn) ? "BLOCK" : "UNBLOCK"
      }
      this.isSubmitDisabled();
  }

  isSubmitDisabled() {
    if (!isNullOrUndefined(this.isActionOn)) {
      this.isSubmitEnabled = true;
    } else {
      this.isSubmitEnabled = false;
    }
  }

}